import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faAngleDoubleLeft, faChevronRight, faChevronLeft,faAngleLeft} from '@fortawesome/free-solid-svg-icons'
import {NavLink} from 'react-router-dom';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import Cookies from 'js-cookie';
import CircularProgress from '@material-ui/core/CircularProgress';

//Start css code ...
import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),   
  },
  addNewStruct: {
    width: '100%',
    '& .MuiPaper-root': {
      width: '100%',
      height: 'auto',
      boxShadow: 'none',
    },
    '& .MuiTextField-root': {
      width: '90%',
    },
    '& input[type="text"]': {
      padding: '10px',
      '@media only screen and (min-width: 3501px)': {
        fontSize:'24pt',
      },
    },
    '& input[type="email"]': {
      padding: '10px',
      '@media only screen and (min-width: 3501px)': {
        fontSize:'24pt',
      },
    },
    '& select#assigned_teams': {
      width: '100%',
      height: '245px',
      padding: '5px',
      fontSize: '15px',
      color:'#333',
    },
    '& select#available_teams': {
      width: '90%',
      height: '245px',
      padding: '5px',
      fontSize: '15px',
      color:'#333',
    },
  },
  firstBox: {

  },
  btbBlock: {
    '@media only screen and (max-width: 3500px)': {
      marginTop: '0px',
    },
    '@media only screen and (min-width: 3501px)': {
      marginTop: '25px',
    },
  },
  signInBtn: {
    border: '1px solid #24618E',
    color: '#fff',
    background: '#24618E!important',    
    '@media only screen and (max-width: 3500px)': {
      width: '150px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '220px',
      marginLeft: '15px',
    },
    '& .MuiCircularProgress-root': {
      width: '25px !important',
      height: '25px !important',
      color: '#fff'
    }
  },
  cancelBtn: {
    border: '1px solid #333',
    color: '#333',
    background: '#fff!important',    
    '@media only screen and (max-width: 3500px)': {
      width: '150px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '220px',
    },
  },
  nextbtn: {
    textAlign: 'center',
    paddingTop: '10px', 
    marginTop:'-15px',   
    '& button': {
      width: '40px',
      height: '40px',
      fontSize: '20px',
      border: '1px solid #24618E',
      borderRadius: '3px',
      padding:'6px',
      cursor:'pointer',
      background:'#fff',
      '& .doubleImg':{
        width:'65%',
      },
      '& .singleImg':{
        width:'45%',
        marginTop: '2px',
      }
    }
  },
  btnIcon: {

  },
  maincontent:{
    width:'100%',
  }
}));
//End css code ...

//Start AddNewUser component code ...
const AddNewUser = (props) => {
  const classes = useStyles();
  const [errPopUp, setErrPopUp] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState(null);
  const [errEmail, setErrEmail] = React.useState(null);
  const [errPassword, setErrPassword] = React.useState(null);
  const [errFirstName, setErrFirstName] = React.useState(null);
  const [errLasttName, setErrLastName] = React.useState(null);
  const [errConfirmPassword, setErrConfirmPassword] = React.useState(null);
  const [errMsgType, setErrMsgType] = React.useState('error');
  const [values, setValues] = React.useState({
    first_name: "",
    last_name: "",
    createdby_email: Cookies.get('email'),
    organization: "",
  });

  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [organization, setOrganization] = React.useState('');
  const [loader, setLoader] = React.useState(false);

  const handleChange = name => event => {
    if (name == 'first_name') {
      setFirstName(event.target.value);
    } else if (name == 'last_name') {
      setLastName(event.target.value);
    } else if (name == 'email') {
      setEmail(event.target.value);
    } else if (name == 'organization') {
      setOrganization(event.target.value);
    } 
    setErrEmail(false);
    setErrFirstName(false);
    setErrLastName(false);
    setValues({ ...values, [name]: event.target.value });
  }
  const ShowErrPopUP = () => {
    setErrPopUp(false)
  };

  //This method is use for form validations ... Start
  const validateForm = async e => {
    e.preventDefault();
    setErrMsg(null);    
    let checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    e.preventDefault()
     if (values.first_name == '') {
      setErrFirstName(true);
      setErrMsgType('error');
      setErrMsg('First Name Required');
      setErrPopUp(true);
    } else if (values.last_name == '') {
      setErrLastName(true);
      setErrMsgType('error');
      setErrMsg('Last Name Required');
      setErrPopUp(true);
    } else if (values.email == '') {
      setErrEmail(true);
      setErrMsgType('error');
      setErrMsg('E-mail Required');
      setErrPopUp(true);
    } else if (!checkEmail.test(values.email)) {
      setErrEmail(true);
      setErrMsgType('error');
      setErrMsg('Email format must be like yourname@example.com');
      setErrPopUp(true);
    }else {
      AddNewUser();
    }
  }
  //This method is use for form validations ... End

  //This method is use for add user api ... start
  const AddNewUser = () => {
    setLoader(true);
    try {
      axios({
        method: 'post',
        data:values
      ,
        headers: {
          'payload':Cookies.get('payload'),
          'agencyid':sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.inviteNewUserAPI,
      })
        .then(function (response) {
          if (response.status && response.status == '200') {
            props.usertabBack();
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true);
            setLoader(false);            
          }
        }).catch(function (error) {
          if (error.response) {
            setErrMsgType('error')            
            setErrMsg(error.response.data.message);            
            setErrPopUp(true);
            setLoader(false);
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true);
            setLoader(false);
          }
        })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for add user api ... End


  return (
    <React.Fragment>    
      <div className={classes.addNewStruct}>
        <div className={classes.root}>   
        <p style={{marginBottom:'10px',marginTop:'0'}}><NavLink to="#" style={{color:'#24618E'}} onClick={props.usertabBack} data-testid='back_to_user_list'><FontAwesomeIcon icon={faAngleLeft}/>&nbsp;Return to User Listing</NavLink></p>    
        <h5 style={{margin:'0',paddingLeft:'12px'}}>Add New User</h5>
        <div className='errMsg' style={{ width: '35%', marginLeft: '18px' }}>
            {errMsg ? <div className={classes.errMsgPassword}><ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> </div> : null}
          </div>
          <Grid container spacing={3} className={classes.maincontent}>
            <Grid item xs={7}>           
              <form className={classes.rootForm} noValidate autoComplete="off" data-testid='details_form' onSubmit={e => validateForm(e)}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="first_name" data-testid="first_name" className={classes.formInput} placeholder="First Name *" type="text" variant="outlined" required onChange={handleChange('first_name')}  value={firstName} />
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="last_name" data-testid="last_name" className={classes.formInput} placeholder="Last Name *" type="text" variant="outlined" required required onChange={handleChange('last_name')} value={lastName} />
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="email" data-testid="email"  className={classes.formInput} placeholder="Email *" type="email" variant="outlined" required onChange={handleChange('email')} value={email} />
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="organization" data-testid="organization" className={classes.formInput} placeholder="Organization *" type="text" variant="outlined" required onChange={handleChange('organization')} value={organization}/>
                      </Paper>
                    </Grid>
                  </Grid>                
                </Grid>
                <Grid item xs={6}>
                  <Paper className={classes.paper}>
                    <div className={classes.btbBlock}>
                      <Button type="reset" variant="outlined" id="cancel_btn"  data-testid="details_cancel_btn" className={classes.cancelBtn}>
                        Cancel</Button>&nbsp;&nbsp;
                       <Button type="submit" variant="outlined" id="save_btn" data-testid="details_save_btn" className={classes.signInBtn}>
                       {loader == true ?
                            <CircularProgress />
                            :
                            'Add User'
                          }
                        </Button>
                    </div>
                  </Paper>
                </Grid>
              </form>
            </Grid>          
          </Grid>
        </div>
      </div>
    </React.Fragment>
  );
}

export default AddNewUser;
//End AddNewUser component code ...